/** 匿名审计主体只有契约登记的三类动作；不通过虚拟运营账号表达系统身份。 */
export const ANONYMOUS_RISK_AUDIT_ACTIONS = [
  'risk_control_auto_ban_device',
  'risk_control_auto_ban_user',
  'risk_control_observe_user',
] as const;
export function isAnonymousRiskAudit(row: { actor_id: string | null; action: string }): boolean {
  return (
    row.actor_id === null && ANONYMOUS_RISK_AUDIT_ACTIONS.some((action) => action === row.action)
  );
}
